/**
 * Filter Match types used for catalog filter matching
 */
export enum FilterMatchType {
  GENESYS_PRODUCT = 'genesysproduct',
  INSTRUCTION_TYPE = 'instructiontype',
  ROLE = 'role',
  TOPIC = 'topic',
  COURSE_AVAILABILITY = 'availability',
}
